import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Radio} from "@mui/material";

import RadioButtonIcon from "components/icons/RadioButtonIcon";

import OrganizationName from "./OrganizationName";
import {grey300} from "../../../../../../../assets/jss/main";

OrganizationButton.propTypes = {
    organization: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

function OrganizationButton({organization, selected = false, onClick = () => {}}) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 0px 8px 8px',
                cursor: 'pointer',
                borderRadius: '8px',
                background: isHovered ? grey300 : 'white',
                height: '40px',
                marginBottom: '8px'
            }}
        >
            <OrganizationName selected={selected} organization={organization} />
            <Radio
                icon={<RadioButtonIcon />}
                checkedIcon={<RadioButtonIcon checked />}
                checked={selected}
            />
        </div>
    );
}

export default OrganizationButton;
